import { render, staticRenderFns } from "./dragKanban.vue?vue&type=template&id=6e527e80"
import script from "./dragKanban.vue?vue&type=script&lang=js"
export * from "./dragKanban.vue?vue&type=script&lang=js"
import style0 from "./dragKanban.vue?vue&type=style&index=0&id=6e527e80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports